import { computed, getCurrentInstance } from 'vue';
import i18n from '../../../shared/locales/i18n';
import { types } from '../../store/types/types';
import { DocumentRevision, DocumentRevisionData } from '../../../shared/models/documentRevision.model';

export const useRevisionTable = () => {
  const { proxy } = getCurrentInstance();

  const revisionData = computed<DocumentRevisionData>(() => proxy.$store.getters[types.GET_DOCUMENTS_REVISION]);
  const revisions = computed<DocumentRevision[]>(() => revisionData.value?.documentRevisionDtos ?? []);

  const fields = computed(() => [
    { key: 'createdBy', label: i18n.t('label.user'), tdClass: 'creator' },
    { key: 'createdAt', label: i18n.t('label.date'), tdClass: 'date' },
    { key: 'description', label: i18n.t('label.action'), tdClass: 'description' },
    { key: 'attachment', label: i18n.t('label.version'), tdClass: 'version' },
  ]);
  const compactFields = computed(() => [{ key: 'compact', label: '', tdClass: 'compact' }]);

  return {
    revisionData,
    revisions,
    fields,
    compactFields,
  };
};
